module.exports = __webpack_public_path__ + "static/404.c5472fb7.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/404.png
// module id = 1580
// module chunks = 5